import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select, { components } from "react-select-v2";
import {
  InputField,
  LabelField,
  MyCheckbox,
  RadioButton,
} from "../../../../components";
import BottomArrowSvg from "../../../../../src/assets/icons/svg/BottomArrowSvg";
import { PriceType } from "pages/NewFinance/NewCharge/ChargeType/PercentageFixed";
import { useFormik } from "formik";
import { DatePickerField } from "_metronic/_partials/controls";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};
const NewEditChargeTypes = ({ type, addNew }) => {
  const [loading, setLoading] = React.useState(false);
  const [discountType, setDiscountType] = useState("%");
  const [taxType, setTaxType] = useState("%");
  const [card, setCard] = useState(null);
  const [localFormat, setLocalFormat] = useState(false);

  const enableLoading = (value) => {
    setLoading(value);
  };
  const radioList = [
    { name: "None", value: "none" },
    { name: "Completely", value: "completely" },
    { name: "Percentage", value: "percentage" },
    { name: "Certain Amount", value: "certain-amount" },
    { name: "All but Amount", value: "all_but_amount" },
  ];
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const formik = useFormik({
    initialValues: {
      tax: "",
      tax_type: "",
    },
  });

  return (
    <>
      <div className="ml-9">
        <div className="col-sm-5 position-relative billing-input-field charge-dollar-sign pb-2 pt-3">
          <InputField
            {...{
              formik,
              name: "charge-types",
              placeholder: addNew === true ? "Charge Type Name" : type,
            }}
            style={{
              height: "48px",
              background: "#F3F6F9",
              borderRadius: "6px",
            }}
          />
        </div>
      </div>
      <div className="billing-amount-details charge-type-fields mt-1 ml-9">
        <div className="col-sm-5 position-relative billing-input-field pb-2  mr-5">
          <div className="form-group">
            <LabelField title={"Parent Ledger"} />
            <Select
              {...{
                formik,
                name: `parent_charge_type`,
                checkValidation: false,
              }}
              classNamePrefix="react-select"
              options={[
                { label: "Member", value: "member" },
                { label: "Not A Member", value: "non-member" },
                { label: "Organization", value: "organization" },
              ]}
              isLoading={loading}
              styles={colourStyles}
              onChange={(value) => {
                formik.setFieldValue(`parent_charge_type`, {
                  value: value.value,
                  label: value.label,
                });
              }}
              value={
                formik.values?.parent_charge_type
                  ? {
                      label: formik.values?.parent_charge_type?.label,
                      value: formik.values?.parent_charge_type?.value,
                    }
                  : ""
              }
              components={{ DropdownIndicator }}
            />
          </div>
        </div>
        <div className="col-sm-5 position-relative new-charge-dollar charge-dollar-sign pb-2 ml-5">
          <InputField
            type="number"
            {...{
              formik,
              title: " Default Amount",
              name: `default_amount`,
              placeholder: "200.00",
            }}
            onKeyDown={(e) => preventArrows(e)}
            style={{ height: "48px" }}
          />
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="currentColor"
              class="bi bi-currency-dollar"
              viewBox="0 0 16 16"
            >
              <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z" />
            </svg>
          </span>
        </div>
      </div>
      <div className=" charge-type-fields mt-1 ml-9">
        <div className="col-sm-12 position-relative radio-btns mr-5">
          <div className="form-group m-0 ml-1">
            <RadioButton
              title="Amount Deductible"
              list={radioList}
              card={card ? card.last4 : null}
              {...{
                formik,
                name: "readioOption",
              }}
            />
          </div>
        </div>
      </div>
      {addNew ? (
        ""
      ) : (
        <div className="input-second-row billing-amount-details amount-deductable-field">
          <div className="col-sm-5 position-relative  charge-percentage-sign charge-dollar-sign pb-2 ml-6 col-md-4">
            <div className="col-md-11 col-sm-6">
              <InputField
                type="number"
                {...{
                  formik,
                  title: "",
                  name: `amount_deductible`,
                  placeholder: "2",
                }}
                onKeyDown={(e) => preventArrows(e)}
              />
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-percent"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      )}
      <hr
        className={
          addNew === true
            ? "horizontal_charge_line mt-15"
            : "horizontal_charge_line"
        }
      ></hr>
      <div
        className={
          addNew === true
            ? "d-flex payments-heading pl-5 ml-9 pt-5 mt-5 mb-15"
            : "d-flex payments-heading pl-5 ml-9 pt-5 mt-5"
        }
      >
        <h2>{"Online Payments"}</h2>
      </div>
      <div className="pb-3 charge-type-fields online-payment-mobile mt-4 ml-10">
        <div className="col-sm-5 m-0 checkbox-chargeEdit  pr-5 mr-5">
          <MyCheckbox
            name={`donation_checkbox`}
            title="Show on donations dropdown"
            handlechange={(event) => {
              formik.setFieldValue("donation_checkbox", event.target.checked);
            }}
            checked={formik.values?.donation_checkbox}
            value={formik.values?.donation_checkbox}
          />
        </div>
        {addNew === true ? (
          ""
        ) : (
          <div className="col-sm-5 position-relative billing-input-field input-field-mobile-view charge-dollar-sign ml-5">
            <InputField
              type="text"
              {...{
                formik,
                title: "Name on dropdown",
                name: `name_on_dropdown`,
                placeholder: "Name",
              }}
              style={{
                color: "#3F4255",
              }}
            />
          </div>
        )}
      </div>
      <div
        className={
          addNew === true
            ? "charge-type-fields online-payment-mobile ml-10 mt-10"
            : "charge-type-fields online-payment-mobile ml-10"
        }
      >
        <div className="col-sm-5 m-0 checkbox-chargeEdit  pr-5 mr-5">
          <MyCheckbox
            name={`requires_notes`}
            title="Requires Notes"
            handlechange={(event) => {
              formik.setFieldValue("requires_notes", event.target.checked);
            }}
            checked={formik.values?.requires_notes}
            value={formik.values?.requires_notes}
          />
        </div>
        <div className="col-sm-5 position-relative charge-dollar-sign input-field-mobile-view ml-5">
          <LabelField title={"Special Rule"} />
          <Select
            {...{
              formik,
              name: `special_rule`,
              checkValidation: false,
            }}
            classNamePrefix="react-select"
            options={[
              { label: "Member", value: "member" },
              { label: "Not A Member", value: "non-member" },
              { label: "Organization", value: "organization" },
            ]}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => {
              formik.setFieldValue(`special_rule`, {
                value: value.value,
                label: value.label,
              });
            }}
            value={
              formik.values?.special_rule
                ? {
                    label: formik.values?.special_rule?.label,
                    value: formik.values?.special_rule?.value,
                  }
                : ""
            }
            components={{ DropdownIndicator }}
          />
        </div>
      </div>
      <div className="billing-amount-details online-payment-mobile charge-type-fields mt-10">
        <div className="col-sm-5 position-relative  pb-2 ml-10 mr-5">
          <DatePickerField
            {...{
              formik,
              name: `recurring_end_date`,
              title: "Recurring Payments Must end by",
              checkValidation: false,
              minDate: formik.values.values?.recurring_end_date,
              value: formik.values.values?.recurring_end_date,
            }}
            value={formik.values.values?.recurring_end_date}
            onChange={(e) => {
              formik.setFieldValue(`recurring_end_date`, e.target.value);
              setLocalFormat(true);
            }}
            localFormat={localFormat}
          />
        </div>
        <div className="col-sm-5 col-12 col-md-3 pr-0 pl-0 ml-5 d-flex input-field-mobile-view align-items-center">
          <div className="">
            <InputField
              type="number"
              {...{
                formik,
                title: "Gateway Fee Override",
                name: `gateway_fee`,

                placeholderIcon: (
                  <span className="placeholder-icon">
                    {taxType === "%" ? "%" : "$"}
                  </span>
                ),
                placeholder: "",
                value: formik.values?.gateway_fee,
                checkValidation: true,
              }}
              onKeyDown={(e) => preventArrows(e)}
              style={{
                backgroundColor: "#F3F6F9",
                border: "none",
              }}
              setFieldValue={formik.setFieldValue}
            />
          </div>
          <div className="price-type dollar-percentage-sign">
            <PriceType
              value={taxType}
              handleClick={setTaxType}
              setFieldValue={formik.setFieldValue}
              type="tax_type"
            />
            {/* </div> */}
          </div>
        </div>
        {/* <div className="col-sm-5 col-12 col-md-2 px-0 d-flex ml-5">
          <InputField
            type="number"
            {...{
              formik,
              title: "Gateway Fee Override",
              name: `values.gateway_fee`,
              placeholderIcon: (
                <span className="placeholder-icon">
                  {taxType === "%" ? "%" : "$"}
                </span>
              ),
              placeholder: "",
              value: formik.values?.gateway_fee,
              checkValidation: true,
            }}
            setFieldValue={formik.setFieldValue}
          />
        </div> */}
      </div>
      <hr className="horizontal_charge_line"></hr>
      <div className=" col-md-5 d-flex payments-heading pl-5 ml-9 pt-5 mt-5">
        <h2>{"Advanced"}</h2>
      </div>
      <div className="billing-amount-details charge-type-fields checkboxes-advanced pt-5 mt-5 pl-5 ml-9">
        <div className="m-0 checkbox-chargeEdit  ">
          <MyCheckbox
            name={`charge_type_VAT`}
            title="This charge type contains VAT (outside US only)"
            handlechange={(event) => {
              formik.setFieldValue("charge_type_VAT", event.target.checked);
            }}
            checked={formik.values?.charge_type_VAT}
            value={formik.values?.charge_type_VAT}
          />
        </div>
        <div className="m-0 checkbox-chargeEdit  pt-4 pr-5 mr-5">
          <MyCheckbox
            name={`charge_type_structure`}
            title="This is only for structure... "
            handlechange={(event) => {
              formik.setFieldValue(
                "charge_type_structure",
                event.target.checked
              );
            }}
            checked={formik.values?.charge_type_structure}
            value={formik.values?.charge_type_structure}
          />
        </div>
        <div className="m-0 checkbox-chargeEdit  pt-4 pr-5 mr-5">
          <MyCheckbox
            name={`special_charge_type`}
            title="Special charge type..."
            handlechange={(event) => {
              formik.setFieldValue("special_charge_type", event.target.checked);
            }}
            checked={formik.values?.special_charge_type}
            value={formik.values?.special_charge_type}
          />
        </div>
        <div className="m-0 checkbox-chargeEdit  pt-4 pr-5 mr-5">
          <MyCheckbox
            name={`administrator_charge_type`}
            title="Available to administrator..."
            handlechange={(event) => {
              formik.setFieldValue(
                "administrator_charge_type",
                event.target.checked
              );
            }}
            checked={formik.values?.administrator_charge_type}
            value={formik.values?.administrator_charge_type}
          />
        </div>
      </div>
      <hr className="horizontal_charge_line"></hr>

      <div className="d-flex justify-content-end action-btns charge-type-btns">
        <button className="btn btn-outline-primary">Cancel</button>
        <button className="btn btn-primary font-weight-bold ml-5 save-button">
          Save
        </button>
      </div>
    </>
  );
};

export default NewEditChargeTypes;
